/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScheduleCreativeDto } from '../models/ScheduleCreativeDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CalendarService {
    /**
     * Get calendar entries for a date range
     * @param from Start date (YYYY-MM-DD)
     * @param to End date (YYYY-MM-DD)
     * @returns any
     * @throws ApiError
     */
    public static calendarControllerGetEntriesV1(
        from: string,
        to: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar/entries',
            query: {
                'from': from,
                'to': to,
            },
        });
    }
    /**
     * Check if any calendar entries exist from the current month onward
     * @returns any
     * @throws ApiError
     */
    public static calendarControllerHasFutureEntriesV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar/entries/has-future',
        });
    }
    /**
     * Get all upcoming calendar entries for the next day
     * @returns any
     * @throws ApiError
     */
    public static calendarControllerGetUpcomingV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar/upcoming',
        });
    }
    /**
     * Schedule or reschedule a creative
     * @param creativeId
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static calendarControllerScheduleCreativeV1(
        creativeId: string,
        requestBody: ScheduleCreativeDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/calendar/entries/{creativeId}/schedule',
            path: {
                'creativeId': creativeId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove a creative from the calendar
     * @param creativeId
     * @returns void
     * @throws ApiError
     */
    public static calendarControllerUnscheduleCreativeV1(
        creativeId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/calendar/entries/{creativeId}/unschedule',
            path: {
                'creativeId': creativeId,
            },
        });
    }
}
